import { WithdrawalClassType } from '../models/request-and-responses/rest-api/enums/withdrawalClassType';

interface IWithdrawalClassObject {
    id: WithdrawalClassType;
    label: string;
}

export const WithdrawalClassObjects: IWithdrawalClassObject[] = [
    {
        id: WithdrawalClassType.FiveDays,
        label: '5 giorni'
    },
    {
        id: WithdrawalClassType.SixDays,
        label: '6 giorni'
    },
    {
        id: WithdrawalClassType.SevenDays,
        label: '7 giorni'
    }
];



// WEBPACK FOOTER //
// ./src/app/helpers/withdrawalClassObjects.ts